import { render, staticRenderFns } from "./selectUser.vue?vue&type=template&id=3b980d94&scoped=true"
import script from "./selectUser.vue?vue&type=script&lang=js"
export * from "./selectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b980d94",
  null
  
)

export default component.exports